var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amui-efficiency-class-icon",class:_vm.classes},[_c('div',{staticClass:"amui-efficiency-class-icon__label"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('svg-corner',{staticClass:"amui-efficiency-class-icon__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }